import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { element } from 'protractor';

@Component({
  selector: 'app-tax-detail',
  templateUrl: './tax-detail.component.html',
  styleUrls: ['./tax-detail.component.css']
})
export class TaxDetailComponent implements OnInit {

  title = ''; name_type = '';
  total = '0'; total_tax = '0'; total_sub_item = '0';
  private dp = [];

  displayedColumns = ['invoice_no', 'invoice_type', 'name', 'mobile', 'tax_no', 'cr_number', 'invoice_date', 
    'sub_item_total', 'tax', 'total'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE2') table: ElementRef;

  From_Date; To_Date; Tax_Name; Acct_No;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private dialogRef: MatDialogRef<TaxDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) { 
      this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Tax_Name').subscribe((res: string) => {
      this.Tax_Name = res;
    });

    translate.get('Acct_No').subscribe((res: string) => {
      this.Acct_No = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });
  }

  ngOnInit() {
    this.total = '0'; 
    this.total_sub_item = '0'; 
    this.total_tax = '0';

    let from_date = this.dialog_data.from_date + " 00:00:00";
    let to_date = this.dialog_data.to_date + " 23:59:59";
    let acct_number = this.dialog_data.acct_number;

    // if (this.dialog_data.acct_number != '')
    //   acct_number = this.dialog_data.acct_number;
    // else
    //   acct_number = '0';

    let obj = {
      cmd: 'getTaxDetail', acct_number: acct_number, from_date: from_date, to_date: to_date, 
      rep_type: this.dialog_data['rep_type']
    };

    if (this.dialog_data['rep_type'] == 'expense' && this.dialog_data['by_invoice'] == '1')
      obj['by_invoice'] = this.dialog_data['by_invoice'];

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;

      });

    if (this.dialog_data['rep_type'] == 'income') {
      this.title = 'تفاصيل تقرير الضريبة للإيرادات';
      this.name_type = 'اسم العميل';
    }
    else {
      this.title = 'تفاصيل تقرير الضريبة للمصروفات';
      this.name_type = 'اسم المورد';
    }
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form3') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0"><tr>';
    html_data += '<td width="40%"> ' + this.Tax_Name + ': ' + (this.applicationConstants.user_lang == 'ar' ? this.dialog_data.tax_name_ar : this.dialog_data.tax_name_en) + '</td>';
    html_data += '<td> ' + this.Acct_No + ': ' + this.dialog_data.acct_number + '</td></tr>';

    html_data += '<tr><td width="40%"> ' + this.From_Date + ': ' + this.dialog_data.from_date + '</td>';
    html_data += '<td> ' + this.To_Date + ': ' + this.dialog_data.to_date + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('rep_table6') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.title);
  }

  close() {
    this.dialogRef.close(this.dialog_data);
  }

}
